// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"256":"1934da80","803":"692e98ee","865":"8545c2f2"}[chunkId] + ".css";
};